// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5397":"5c5cd772215d0341","7997":"8f4c374f059463e0"}[chunkId] + ".css";
};